import React, {Component} from 'react';
import PropTypes from 'prop-types';
import CreateNewButton from '../CreateNewButton';
import i18next from 'i18next';

class WhitePortlet extends Component {
  render() {
    const iconClass = `${this.props.icon}`;

    return (
      <div className="row">
        <div className="col-md-12">
          <div className="portlet light portlet-fit portlet-datatable bordered">
            <div className="portlet-title">
              <div className="caption">
                <i className={iconClass} style={{color: '#DA002F'}}/>
                <span className="caption-subject sbold uppercase">{this.props.caption}</span>
              </div>
              {this.props.addButtonCallback ?
                <div className={'active-switch'}>
                  <CreateNewButton
                    callBack={this.props.addButtonCallback}
                  />
                </div> :
                null
              }
              {this.props.hapiLinkCallback !== null ?
                <button
                  style={{borderRadius: '5px', float: 'right', color: '#FFF'}}
                  className="btn default-button"
                  onClick={() => this.props.hapiLinkCallback(this.props.siteId)}
                >
                  {i18next.t('sites.attrs.hapi_details')}
                  <i style={{marginLeft: '10px', color: '#FFF'}} className="fa fa-external-link"/>&nbsp;
                </button> : null
              }
              <div className={this.props.actionsType === 'active-switch' ? 'active-switch' : 'actions'}>
                {this.props.actions}
              </div>
            </div>
            <div className="portlet-body">
              {this.props.children}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

WhitePortlet.propTypes = {
  children: PropTypes.node,
  caption: PropTypes.string,
  icon: PropTypes.string,
  actions: PropTypes.any,
  actionsType: PropTypes.string,
  addButtonCallback: PropTypes.func,
  hapiLinkCallback: PropTypes.func,
  siteId: PropTypes.number,
};

WhitePortlet.defaultProps = {};

export default WhitePortlet;
